<template>
  <tr>
    <td>{{ refinementName }}</td>
    <td>
      <span class="text-primary cursor--pointer" @click="show">
        <i class="fa fa-info-circle"></i> {{ (inEnglish) ? printArticle.article.name_en : printArticle.article.name }}
      </span>
    </td>
    <td class="text-right">
      {{ $filters.formatMoney(configuration.count * pricePerUnit) }}
    </td>
    <td>
      <span v-if="hasUpload"
        class="text-primary cursor--pointer"
        @click="download(configuration.file)">
        <i class="fa fa-download"></i> {{ configuration.file.original_name }}
      </span>
      <span v-else class="bg-warning">
        <i class="fa fa-warning text-warning"></i> {{ $t('configurator.labels.upload_missing') }}
      </span>
    </td>
    <td>
      <span v-if="isCloudStatusOpen"
        class="text-primary cursor--pointer"
        @click="confirmRemoveFromBasket">
        <i class="fa fa-trash"></i> {{ $t('configurator.buttons.remove_from_basket') }}
      </span>
    </td>
  </tr>
</template>

<script setup>
/*
 TODO: put upload and modal in parent component?
 */
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { downloadFile } from '@/utils/file'
import Swal from 'sweetalert2'
import { PRINT_CLOUD_STATUS_OPEN } from '@/constants'
import { useI18n } from 'vue-i18n'
import { addLateDeliverySurcharge } from '@/utils/helper'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define props
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  },
  article: {
    type: Object,
    required: true
  },
})
// define emits
const emit = defineEmits(['show', 'remove'])
// define computed
const locale = computed(() => store.settings.locale)
const cloud = computed(() => store.tmp.cloud)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const hasUpload = computed(() => {
  return (props.configuration.file)
})

const isCloudStatusOpen = computed(() => {
  return cloud.value.status === PRINT_CLOUD_STATUS_OPEN
})

const print = computed(() => {
  return props.article.prints.find((print) => {
    return print.id === props.configuration.id
  })
})

const printArticle = computed(() => {
  return props.article.prints.find((printArticle) => {
    return printArticle.id === props.configuration.id
  })
})

const refinementName = computed(() => {
  return (inEnglish.value)
    ? printArticle.value.article_print.name_en
    : printArticle.value.article_print.name
})

const pricePerUnit = computed(() => {
  return (earlyBirdMode.value)
    ? addLateDeliverySurcharge(printArticle.value.exhibition_prices.price_net, lateDelivery.value)
    : printArticle.value.exhibition_prices.price_net
})
// define methods
const show = () => {
  emit('show', printArticle.value)
}
const remove = () => {
  emit('remove', props.configuration)
}

const download = async (upload) => {
  await downloadFile(
    '/print/' + cloud.value.uuid + '/download/' + upload.id,
    upload.original_name
  )
}

const confirmRemoveFromBasket = (upload) => {
  Swal.fire({
    title: t('configurator.notices.titles.remove_print_article'),
    text: t('configurator.notices.messages.remove_print_article'),
    showCancelButton: true,
    confirmButtonText: t('configurator.buttons.yes'),
    cancelButtonText: t('configurator.buttons.no'),
  })
    .then((result) => {
      if (result.isConfirmed) {
        remove()
      }
    })
}
</script>